module.exports = require("rxjs/observable/merge");


//////////////////
// WEBPACK FOOTER
// external "rxjs/observable/merge"
// module id = 267
// module chunks = 0